<template>
    <div v-if="filteredBreadcrumbs.length > 1"
         class="flex flex-row justify-between items-center relative skewer mx-8">
        <div
            v-for="crumb in filteredBreadcrumbs"
            :key="crumb.name"
            class="flex justify-center bg-navy-light z-40 desktop:w-40 px-3 desktop:px-4"
        >
            <button
                @click.prevent="$emit('breadcrumb-navigate', { name: crumb.name })"
                :class="{ 'border-navy text-navy cursor-default': crumb.name === currentRouteName }"
                class="border-b-2 desktop:border-b-4 border-navy-light text-blue font-bold text-center text-sm hover:text-navy hover:cursor-pointer"
            >
                <span class="hidden desktop:inline">{{ crumb.text }}</span>
                <span class="desktop:hidden">{{ crumb.shortText }}</span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AppBreadcrumbs',
        props: {
            currentRouteName: {
                type: String,
                required: true,
                default: null,
            },
            breadcrumbs: {
                type: Array,
                required: true,
                default: () => [],
            },
            sectionStatus:{
                type: Function,
                required: true,
            }
        },
        computed: {
            filteredBreadcrumbs() {
                return this.breadcrumbs.filter(crumb => {
                    return !this.sectionStatus('buyflow_hide', crumb.shortText.toLowerCase())
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .skewer {
        &::before {
            content: '';
            height: 1px;
            @apply absolute
                   w-full
                   bg-navy
                   z-10
                   opacity-30;
        }
    }
</style>
